import React, { useEffect } from "react";
import "./Wishlist.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Product_card from "../common-components/product_card/Product_card";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";

function Wishlist() {
  const wishlistProducts = [
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    // Add more products as needed
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },

    // Add more products as needed
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
  ];

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "WISHLIST", link: "", isActive: true },
  ];

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  return (
    <>
      <section className="Wishlist">
        <div className="container">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          <div className="heading_holder">
            <h4 className="heading_text"> My Wishlist</h4>
          </div>
          <div className="row">
            {allWishlist?.data?.length > 0 ? (
              allWishlist.data.map((product, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6 col-6" key={index}>
                  <Product_Info_Card
                    product={product?.Product}
                    id={product?.Product?.id}
                    imgSrc={
                      process.env.REACT_APP_IMG_URL + product?.Product?.image
                    }
                    productName={product?.Product?.name}
                    priceText={product.Product?.Product_Variants[0]?.price}
                    kgText={product?.Product?.Product_Variants[0]?.name}
                    savingPrice={
                      parseFloat(
                        product?.Product?.Product_Variants[0]?.mrp || 0
                      ) -
                      parseFloat(
                        product?.Product?.Product_Variants[0]?.price || 0
                      )
                    }
                  />

                  {/* old card */}
                  {/* <Product_card
                    product={product?.Product}
                    id={product?.Product?.id}
                    imgSrc={process.env.REACT_APP_IMG_URL + product?.Product?.image}
                    productName={product?.Product?.name}
                    priceText={product.Product?.Product_Variants[0]?.price}
                    kgText={product?.Product?.Product_Variants[0]?.name}
                    savingPrice={
                      parseFloat(product?.Product?.Product_Variants[0]?.mrp || 0) -
                      parseFloat(product?.Product?.Product_Variants[0]?.price || 0)
                    }
                  />                 */}
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Product Added In Wishlist</h3>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Wishlist;
